import { getKitSciVersion } from '@repo/utils';
import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';
import { useQuery } from '@tanstack/react-query';
import { API } from 'api';

import { KitType } from '@repo/types';
import { apiBasePath, apiName } from 'assets';
import { stoolToGut } from 'helpers';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';

export function getInsightCategoryDetail(
  kitId: string,
  categoryId: number,
  sciVersion: string,
) {
  const res = API.get(
    apiName,
    `${apiBasePath}/results/kitInsightDetailWithTaxaById/${kitId}/${categoryId}/${sciVersion}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.INSIGHTS,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId,
        categoryId,
        sciVersion,
      },
    },
  );
  return res;
}

const useInsightCategoryDetailById = (categoryId: number) => {
  const { currentKitId, currentKitType, currentKit } =
    useCurrentKitAndTinyAccount();
  const sciVersion = getKitSciVersion(currentKit);

  const insightsDataQuery = useQuery({
    queryKey: [
      apiName,
      `${stoolToGut(currentKitType ?? KitType.STOOL)}InsightDetail`,
      currentKitId,
      categoryId,
      sciVersion,
    ],
    queryFn: () =>
      currentKitId && sciVersion
        ? getInsightCategoryDetail(currentKitId, categoryId, sciVersion)
        : undefined,
  });

  return insightsDataQuery;
};

export default useInsightCategoryDetailById;
